import { useCallback, useState } from 'react';
import { hasAnyFilter } from '../../../utils/beneficiaryUtils';
const CONTRACT_TYPES = ['Empregado', 'Contribuinte', 'Estagiário'];
const initialFilters = {
    name: undefined,
    startDate: undefined,
    endDate: undefined,
    contractType: [],
    cardStatus: [],
    jobRole: [],
    costCenter: [],
    department: [],
    category: [],
    employmentBond: [],
    branch: [],
    union: [],
};
export function useBeneficiaryFilter(onFilter) {
    const [filters, setFilters] = useState(initialFilters);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const setAppliedFiltersAndNotify = useCallback((newFilters) => {
        setAppliedFilters(newFilters);
        onFilter(newFilters);
    }, [onFilter]);
    const updateFilter = useCallback((key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value,
        }));
    }, []);
    const clearFilters = useCallback(() => {
        setFilters(initialFilters);
        setAppliedFilters(null);
        onFilter(initialFilters);
    }, [onFilter]);
    const clearFiltersExceptName = useCallback(() => {
        const currentName = appliedFilters?.name;
        const clearedFilters = {
            ...initialFilters,
            name: currentName,
        };
        setFilters(clearedFilters);
        if (currentName) {
            setAppliedFilters(clearedFilters);
            onFilter(clearedFilters);
        }
        else {
            setAppliedFilters(null);
            onFilter(initialFilters);
        }
    }, [appliedFilters, onFilter]);
    const removeFilter = useCallback((key) => {
        setAppliedFilters(prev => {
            if (!prev)
                return null;
            const updatedFilters = {
                ...prev,
                [key]: key === 'startDate' || key === 'endDate' ? undefined : [],
            };
            if (key === 'startDate' || key === 'endDate') {
                updatedFilters.startDate = undefined;
                updatedFilters.endDate = undefined;
            }
            if (!hasAnyFilter(updatedFilters)) {
                onFilter(initialFilters);
                return null;
            }
            onFilter(updatedFilters);
            return updatedFilters;
        });
        setFilters(prev => {
            const updated = {
                ...prev,
                [key]: key === 'startDate' || key === 'endDate' ? undefined : [],
            };
            if (key === 'startDate' || key === 'endDate') {
                updated.startDate = undefined;
                updated.endDate = undefined;
            }
            return updated;
        });
    }, [onFilter]);
    const hasActiveFilters = useCallback(() => {
        return hasAnyFilter(filters);
    }, [filters]);
    const applyFilters = useCallback(() => {
        setAppliedFilters(filters);
        onFilter(filters);
    }, [filters, onFilter]);
    return {
        filters,
        appliedFilters,
        updateFilter,
        clearFilters,
        clearFiltersExceptName,
        removeFilter,
        hasActiveFilters: hasActiveFilters(),
        applyFilters,
        setAppliedFilters: setAppliedFiltersAndNotify,
    };
}
